import {
    SAVE_FULL_TRUCKLOAD,
    FETCH_FULL_TRUCKLOADS,
    DELETE_FULL_TRUCKLOAD,
    STORE_FULL_TRUCKLOAD,
    UPDATE_FULL_TRUCKLOAD,
    SAVE_FULL_TRUCKLOAD_SETTINGS,
    CLEAR_FTL_SETTING_SAVE_RESPONSE_MESSAGE,
    STORE_FULL_TRUCKLOAD_SETTINGS,
    FETCH_FULL_TRUCKLOAD_SETTINGS,
    PREVIEW_FULL_TRUCKLOAD_FILE,
    STORE_FULL_TRUCKLOAD_FILE,
    LIST_FULL_TRUCKLOAD_CARRIERS,
    STORE_FULL_TRUCKLOAD_CARRIERS,
    PREVIEW_FULL_TRUCKLOAD_DOCUMENT,
    STORE_FULL_TRUCKLOAD_DOCUMENT,
    LIST_FULL_TRUCKLOAD_BROKERS,
    STORE_FULL_TRUCKLOAD_BROKERS,
    UPLOAD_SIGNED_DOCUMENTS,
    STORE_FULL_TRUCKLOAD_OPERATIONS_RESPONSE,
    STORE_FULL_TRUCKLOAD_UNAVAILABLE_ITEMS,
    SAVE_FULL_TRUCKLOAD_SIGNATURES,
    STORE_FULL_TRUCKLOAD_SIGNATURES,
    STORE_SAVE_FTL_SETTING_RESPONSE,
    LIST_FULL_TRUCKLOAD_SIGNATURES,
    STORE_FULL_TRUCKLOAD_SIGNATURE,
    STORE_SAVE_SIGNATURE_RESPONSE,
    STORE_SAVE_POE_RESPONSE,
    CLEAR_RESPONSE_MESSAGE,
    LIST_FULL_TRUCKLOAD_NOA_PORTS,
    STORE_FULL_TRUCKLOAD_PORTS,
    SAVE_FULL_TRUCKLOAD_NOA_PORTS,
    FETCH_PRODUCT_SUPPLIERS,
    STORE_PRODUCTS_SUPPLIERS, REIMPORT_FTL_FINAL_DOC, REGENERATE_FTL_DOCUMENT, UPDATE_FTL_DRAFT,
} from '../../constants/fullTruckload';
import {STORE_FULL_TRUCKLOADS_BROKERS} from "../../constants/fullTruckloadBrokers";

export const fetchFullTruckloads = () => ({
    type: FETCH_FULL_TRUCKLOADS,
})

export const deleteFullTruckload = (data) => ({
    type: DELETE_FULL_TRUCKLOAD,
    data
})

export const reimportFTLFinalDoc = (data) => ({
    type: REIMPORT_FTL_FINAL_DOC,
    data
})

export const saveFullTruckload = (data, newSettings, reset, callback) => ({
    type: SAVE_FULL_TRUCKLOAD,
    data,
    newSettings,
    reset,
    callback
})
export const regenerateFTLDocument = (data, reset) => ({
    type: REGENERATE_FTL_DOCUMENT,
    data,
    reset,
})

export const updateFullTruckload = (data, newSettings, reset, operationName = undefined) => ({
    type: UPDATE_FULL_TRUCKLOAD,
    data,
    newSettings,
    reset,
    operationName,
})

export const saveFTLDraft = (data, callback) => ({
    type: UPDATE_FTL_DRAFT,
    data,
    callback
})

export const fetchProductSuppliers = (items) => ({
    type: FETCH_PRODUCT_SUPPLIERS,
    items
})

export const storeProductsSuppliers = (suppliers) => ({
    type: STORE_PRODUCTS_SUPPLIERS,
    suppliers
})

export const uploadSignedDocuments = (data, reset) => ({
    type: UPLOAD_SIGNED_DOCUMENTS,
    data,
    reset
})

export const storeFullTruckloads = (data) => ({
    type: STORE_FULL_TRUCKLOAD,
    data,
})

export const saveFullTruckloadSettings = (data, reset) => ({
    type: SAVE_FULL_TRUCKLOAD_SETTINGS,
    data,
    reset
})
export const clearFtlSettingSaveResponseMessage = () => ({
    type: CLEAR_FTL_SETTING_SAVE_RESPONSE_MESSAGE
})


export const saveFullTruckloadSignatures = (data, reset) => ({
    type: SAVE_FULL_TRUCKLOAD_SIGNATURES,
    data,
    reset
})

export const listFullTruckloadPOEs = () => ({
    type: LIST_FULL_TRUCKLOAD_NOA_PORTS
})

export const saveFullTruckloadPOEs = (data) => ({
    type: SAVE_FULL_TRUCKLOAD_NOA_PORTS,
    data
})

export const clearSignatureRelatedResponseMessage = () => ({
    type: CLEAR_RESPONSE_MESSAGE
})

export const listFullTruckloadSignatures = () => ({
    type: LIST_FULL_TRUCKLOAD_SIGNATURES,
})

export const storeFullTruckloadSettings = (data) => ({
    type: STORE_FULL_TRUCKLOAD_SETTINGS,
    data,
})

export const storeSaveSignatureResponse = (data) => ({
    type: STORE_SAVE_SIGNATURE_RESPONSE,
    data
})
export const storeSavePOEResponse = (data) => ({
    type: STORE_SAVE_POE_RESPONSE,
    data
})
export const storeSaveFtlSettingResponse = (data) => ({
    type: STORE_SAVE_FTL_SETTING_RESPONSE,
    data
})
export const storeFullTruckloadSignatures = (data) => ({
    type: STORE_FULL_TRUCKLOAD_SIGNATURES,
    data,
})

export const storeFullTruckloadPorts = (data) => ({
    type: STORE_FULL_TRUCKLOAD_PORTS,
    data
})

export const fetchFullTruckloadSettings = () => ({
    type: FETCH_FULL_TRUCKLOAD_SETTINGS,
})

export const previewFullTruckloadFile = (previewRequest) => ({
    type: PREVIEW_FULL_TRUCKLOAD_FILE,
    previewRequest
})

export const storeUpdatedFullTruckloadSettingsWithFile = (fullTruckloadSettings, index) => ({
    type: STORE_FULL_TRUCKLOAD_FILE,
    fullTruckloadSettings,
    index
})

export const storeUpdatedFullTruckloadSignaturesWithFile = (fullTruckloadSignatures, index) => ({
    type: STORE_FULL_TRUCKLOAD_SIGNATURE,
    fullTruckloadSignatures,
    index
})

export const previewFullTruckloadDocument = (previewRequest) => ({
    type: PREVIEW_FULL_TRUCKLOAD_DOCUMENT,
    previewRequest
})

export const storeUpdatedFullTruckloadWithFile = (data) => ({
    type: STORE_FULL_TRUCKLOAD_DOCUMENT,
    data
})

export const listFullTruckloadCarriers = () => ({
    type: LIST_FULL_TRUCKLOAD_CARRIERS
})

export const storeFullTruckloadCarriers = (data) => ({
    type: STORE_FULL_TRUCKLOAD_CARRIERS,
    data
})

export const listFullTruckloadBrokers = () => ({
    type: LIST_FULL_TRUCKLOAD_BROKERS
})

export const storeFullTruckloadBrokers = (data) => ({
    type: STORE_FULL_TRUCKLOADS_BROKERS,
    data
})

export const storeFullTruckloadOperationsResponse = (message) => ({
    type: STORE_FULL_TRUCKLOAD_OPERATIONS_RESPONSE,
    message
})

export const storeFullTruckloadUnavailableItems = (items) => ({
    type: STORE_FULL_TRUCKLOAD_UNAVAILABLE_ITEMS,
    items
})